import api from './api';
import { Period } from '../types';

export interface PeriodFilters {
  is_active?: boolean;
  is_closed?: boolean;
  type?: 'monthly' | 'quarterly' | 'yearly' | 'custom';
}

export interface CreatePeriodData {
  name: string;
  type: 'monthly' | 'quarterly' | 'yearly' | 'custom';
  start_date: string;
  end_date: string;
  description?: string;
}

export interface UpdatePeriodData {
  name?: string;
  type?: 'monthly' | 'quarterly' | 'yearly' | 'custom';
  start_date?: string;
  end_date?: string;
  description?: string;
}

export const periodApi = {
  getPeriods: async (filters?: PeriodFilters): Promise<Period[]> => {
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, String(value));
        }
      });
    }
    const queryString = params.toString();
    const url = queryString ? `/periods?${queryString}` : '/periods';
    const response = await api.get(url);
    return response.data;
  },

  getPeriod: async (id: number): Promise<Period> => {
    const response = await api.get(`/periods/${id}`);
    return response.data;
  },

  createPeriod: async (data: CreatePeriodData): Promise<Period> => {
    const response = await api.post('/periods', data);
    return response.data;
  },

  updatePeriod: async (id: number, data: UpdatePeriodData): Promise<Period> => {
    const response = await api.put(`/periods/${id}`, data);
    return response.data;
  },

  deletePeriod: async (id: number): Promise<void> => {
    await api.delete(`/periods/${id}`);
  },

  setActive: async (id: number): Promise<{ message: string; period: Period }> => {
    const response = await api.post(`/periods/${id}/set-active`);
    return response.data;
  },

  close: async (id: number): Promise<{ message: string; period: Period }> => {
    const response = await api.post(`/periods/${id}/close`);
    return response.data;
  },

  reopen: async (id: number): Promise<{ message: string; period: Period }> => {
    const response = await api.post(`/periods/${id}/reopen`);
    return response.data;
  },

  getActive: async (): Promise<Period> => {
    const response = await api.get('/periods/active/current');
    return response.data;
  },
};
